// Single source of truth for supported languages.
// `code` doubles as the i18next resource key and the URL prefix segment
// (the default language has no URL prefix).
export const DEFAULT_LANGUAGE = 'en';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', urlPrefix: null, label: 'English (US)', htmlLang: 'en', ogLocale: 'en_US' },
  { code: 'es', urlPrefix: 'es', label: 'Español', htmlLang: 'es', ogLocale: 'es_ES' },
  { code: 'fr', urlPrefix: 'fr', label: 'Français', htmlLang: 'fr', ogLocale: 'fr_FR' },
  { code: 'de', urlPrefix: 'de', label: 'Deutsch', htmlLang: 'de', ogLocale: 'de_DE' },
];

// Language codes that appear as a URL prefix (excludes the default).
export const PREFIXED_LANGUAGE_CODES = SUPPORTED_LANGUAGES
  .filter((l) => l.urlPrefix)
  .map((l) => l.urlPrefix);

export const isSupportedPrefix = (code) => PREFIXED_LANGUAGE_CODES.includes(code);

export const getLanguageByCode = (code) =>
  SUPPORTED_LANGUAGES.find((l) => l.code === code);
